import React, { useState, useEffect } from "react";
import Icon from "../../components/ui/icon";
import "../../assets/styles/pages/publishers/invoiceDetails.css";
import SideNav from "../../components/layout/sideNav";
import { useToast } from "../../context/toastContext";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../services/apiClient";
import moment from "moment-timezone";
import { convertCurrency } from "../../utils/currencyConverter";
import { storageManager } from "../../utils/storageManager";
import { getTimezoneByCountry } from "../../utils/getTimezoneByCountry";

const InvoiceDetailsPage = () => {
  const navigate = useNavigate();
  const showToast = useToast();
  const [isSideNavActive, setisSideNavActive] = useState(false);
  const [userInfo, setUserInfo] = useState(
    JSON.parse(localStorage.getItem("PublisherInfo")) || {}
  );
  const [invoiceInfo, setInvoiceInfo] = useState({});
  const [unival, setUnival] = useState(0);
  const [invoiceLoading, setInvoiceInfoLoading] = useState(true);
  const { invoiceID } = useParams();
  const currency = storageManager.getCurrency();
  const country = userInfo?.country?.toLowerCase() || "india";

  useEffect(() => {
    const token = localStorage.getItem("aToken");
    if (!token) {
      navigate("/auth/login");
      return;
    }

    api
      .get(`/api/publisher/info`)
      .then((response) => {
        setUserInfo(response.data.data);
        localStorage.setItem(
          "PublisherInfo",
          JSON.stringify(response.data.data)
        );
        api
          .get(`/api/invoice/${invoiceID}`)
          .then((response) => {
            console.log(response.data);
            setInvoiceInfo(response.data.invoice);
            setUnival(response.data.unival);
            setInvoiceInfoLoading(false);
          })
          .catch((err) =>
            showToast({
              status: "error",
              message:
                err.response?.data?.message ||
                "Unable to fetch invoice information.",
            })
          );
      })
      .catch((err) => {
        showToast({
          status: "error",
          message: err.response?.data?.message || "Login not found.",
        });
        navigate("/auth/login");
      });
  }, [invoiceID, navigate, showToast]);

  const formatNumber = (num) => {
    if (num < 1000) return num;
    if (num < 1_000_000)
      return (num / 1000).toFixed(num % 1000 === 0 ? 0 : 1) + "K";
    if (num < 1_000_000_000)
      return (num / 1_000_000).toFixed(num % 1_000_000 === 0 ? 0 : 1) + "M";
    return (
      (num / 1_000_000_000).toFixed(num % 1_000_000_000 === 0 ? 0 : 1) + "B"
    );
  };

  return (
    <div className={`idetails__page ${invoiceLoading ? "loading" : ""}`}>
      <SideNav
        userName={userInfo.name}
        emailID={userInfo.email}
        active={isSideNavActive}
        campaignOpenInital={false}
        accManagerName={userInfo.adminInfo?.name}
        accManagerEmail={userInfo.adminInfo?.email}
      />
      <div
        onClick={() => setisSideNavActive(!isSideNavActive)}
        className={
          isSideNavActive ? "background-shadow active" : "background-shadow"
        }
      ></div>
      <main>
        <header className="desktop-header">
          <div>
            <h2>Invoice Details - #{invoiceID}</h2>
            <p>Get information about your invoice generated.</p>
          </div>
        </header>

        <header className="mobile-header">
          <div>
            <h2>Invoice</h2>
          </div>
          <button
            className="nav-btn"
            onClick={() => setisSideNavActive(!isSideNavActive)}
          >
            {isSideNavActive ? (
              <Icon name="XMark" className="onLeft" />
            ) : (
              <Icon name="Bars3" className="onLeft" />
            )}
          </button>
        </header>

        <div className="top-container">
          <div className="date-infos">
            <div className="date">
              <span>Issued On</span>
              <span>
                {moment
                  .tz(invoiceInfo.withdrawalRequestedAt, getTimezoneByCountry(country))
                  .format("DD MMMM YYYY")}
              </span>
            </div>
            <div className="divider"></div>
            <div className="date">
              <span>Completed On</span>
              <span>
                {invoiceInfo.status !== "paid"
                  ? "Not Yet"
                  : moment
                    .tz(invoiceInfo.paidAt, getTimezoneByCountry(country))
                    .format("DD MMMM YYYY")}
              </span>
            </div>
          </div>
          <Icon name="DocumentText" className="mainIcon" />
        </div>

        <div className="infos-container">
          <div className="info-container">
            <div className="infos">
              <span>Payment Method:</span>
              <span>
                {invoiceInfo?.payoutType?.toUpperCase() || "Loading..."}
              </span>
            </div>
            <div className="infos">
              <span>UPI ID</span>
              <span>{invoiceInfo.payoutAddress || "Loading..."}</span>
            </div>
            <div className="infos">
              <span>Time</span>
              <span>
                {invoiceInfo
                  ? moment
                    .tz(invoiceInfo.withdrawalRequestedAt, getTimezoneByCountry(country))
                    .format("h:mm A")
                  : "Loading..."}
              </span>
            </div>
          </div>

          <div className="info-container">
            <div className="infos">
              <span>Amount Expected:</span>
              <span>
                {convertCurrency(invoiceInfo.amount, "INR", currency)}
              </span>
            </div>
            <div className="infos">
              <span>Tax(0%)</span>
              <span>{convertCurrency(0, "INR", currency)}</span>
            </div>
            <div className="infos">
              <span>Final Amount</span>
              <span>
                {convertCurrency(invoiceInfo.amount, "INR", currency)}
              </span>
            </div>
          </div>
        </div>

        <div
          className={`message-container ${invoiceInfo?.status === "pending" ||
            invoiceInfo?.status === "approved"
            ? "active"
            : ""
            }`}
        >
          <Icon name="InformationCircle" />
          <div>
            <h3>Your invoice is approved.</h3>
            <p>
              We have successfully approved your invoice. You can expect the
              payment in your account within 24 hours.
            </p>
          </div>
        </div>

        <div className="didYouKnow-container">
          <Icon name="FaceSmile" />
          <h3>Did you know?</h3>
          <p>
            We have succesfully proccessed more than{" "}
            <strong>
              {formatNumber(unival - 1)} {unival <= 2 ? "invoice" : "invoices"}
            </strong>{" "}
            till date.
          </p>
        </div>

        <span className="thanks-text">Thanks for choosing Swift Digital Ads.</span>
      </main>
    </div>
  );
};

export default InvoiceDetailsPage;
